import { Link } from "react-router-dom";
import { FaRegEye } from "react-icons/fa";
import ReactRating from "../ReactRate/RateStars";
import { useState } from "react";

export default function ItemCard({ index, clsName, item }) {
  const [isLoaded, setIsLoaded] = useState(false);

  const onLoaded = () => {
    setIsLoaded(true);
  };

  const formattedProductName = (productName) => {
    return productName.replace(/[^\w\s]/gi, "").replace(/\s+/g, "-");
  };

  return (
    <>
      {item && (
        <div key={index} className={`${clsName} p-2 text-decoration-none`}>
          <Link
            to={`/products/${item.id}/${formattedProductName(item.name)}`}
            // target="_blank"
            className="text-decoration-none"
          >
            <div
              style={{ borderRadius: "6px" }}
              className="col-12 bg-white shadow d-flex flex-column justify-content-between p-2 h-100"
            >
              <div>
                <div
                  style={{ display: isLoaded ? "none" : "block" }}
                  className="shine shadow item-image"
                ></div>
                <img
                  onLoad={onLoaded}
                  alt="img"
                  className="shadow item-image"
                  src={`${item.images &&
                    item.images.length > 0 &&
                    Object.values(item.images[0])[0]
                    }`}
                  style={{
                    borderRadius: "6px",
                    objectFit: "cover",
                    display: isLoaded ? "block" : "none",
                  }}
                />

                <div
                  style={{
                    fonFamily: "Poppins",
                    fontWeight: 600,
                    textAlign: "left",
                    color: "#000",
                  }}
                >
                  <div className="d-flex justify-content-between">
                    <p className="p-0 mt-2 mb-0 item-list-title">{item.name}</p>
                    <div className="d-flex my-auto text-secondary small fw-light">
                      <span>{item.views}</span>&nbsp;
                      <FaRegEye className="my-auto" />
                    </div>
                  </div>
                  <ReactRating rate={item.condition} />
                  <span
                    className="p-0 mt-0 item-list-extra"
                    style={{
                      fontWeight: 400,
                    }}
                  >
                    {item.date_of_purchase}
                  </span>
                </div>
              </div>
              <div
                className="d-flex justify-content-between "
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 600,
                  textAlign: "left",
                  color: "#000",
                }}
              >
                <p className="my-auto item-list-price">Rs. {item.price}</p>
                <p
                  style={{ color: "#ec008c" }}
                  className="my-auto item-list-extra"
                >
                  Details &gt;
                </p>
              </div>
            </div>
          </Link>
        </div>
      )}
    </>
  );
}
